(() => {
  if (customElements.get('gift-card-recipient')) return;
  class GiftCardRecipient extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.product = this.closest('modular-product');
      this.enabled = this.querySelector('[data-gift-enabled]');
      this.fields = this.querySelector('[data-gift-fields]');
      this.email = this.querySelector('[data-gift-email]');
      this.message = this.querySelector('[data-gift-message]');
      this.date = this.querySelector('[data-gift-date]');
      this.querySelector('[data-gift-fallback]').hidden = true;
      this.querySelector('[data-gift-modes]').hidden = false;
      this.querySelector('[data-gift-offset]').disabled = false;
      this.product.addEventListener('change', event => {
        if (event.target.matches('[data-gift-mode]')) {
          this.enabled.checked = event.target.value === 'recipient';
          this.sync();
        }
        if (event.target.matches('[data-gift-quick]')) {
          const select = this.product.querySelector('[data-gift-variant]');
          select.value = event.target.value;
          this.product.selectVariant(select, event.target.id);
        }
        if (event.target === this.date) this.validateDate();
      }, options);
      this.message.addEventListener('input', () => this.preview(), options);
      this.querySelector('[data-gift-name]').addEventListener('input', () => this.preview(), options);
      this.product.addEventListener('gift:variant', () => this.preview(), options);
      this.date.addEventListener('focus', () => this.validateDate(), options);
      this.product.addEventListener('submit', () => this.validateDate(), { ...options, capture: true });
      this.validateDate();
      if (!this.date.value && !this.date.dataset.initialized) this.date.value = this.date.min;
      this.date.dataset.initialized = 'true';
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
    sync() {
      const enabled = this.enabled.checked;
      this.fields.hidden = !enabled;
      this.fields.disabled = !enabled;
      this.email.required = this.date.required = this.querySelector('[data-gift-name]').required = enabled;
      this.querySelector('[data-gift-self-help]').hidden = enabled;
      this.querySelector('[data-gift-recipient-help]').hidden = !enabled;
      this.validateDate();
      this.preview();
    }
    validateDate() {
      const today = new Date();
      const end = new Date(today);
      end.setDate(end.getDate() + 90);
      const localDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      this.date.min = localDate(today);
      this.date.max = localDate(end);
      // Keep today visible, but omit Shopify's scheduling property for immediate delivery.
      if (this.date.value > this.date.min) this.date.name = 'properties[Send on]';
      else this.date.removeAttribute('name');
      this.querySelector('[data-gift-offset]').value = today.getTimezoneOffset();
      this.date.setCustomValidity(this.enabled.checked && this.date.value && (this.date.value < this.date.min || this.date.value > this.date.max) ? this.dataset.dateError : '');
    }
    preview() {
      this.product.querySelectorAll('[data-gift-quick-list]').forEach(list => { list.hidden = false; });
      const preview = this.product.querySelector('[data-gift-preview-message]');
      const recipient = this.product.querySelector('[data-gift-preview-recipient]');
      if (recipient) {
        const name = this.querySelector('[data-gift-name]').value.trim();
        recipient.hidden = !this.enabled.checked || !name;
        recipient.textContent = recipient.dataset.template.replace('[name]', name);
      }
      if (preview) preview.textContent = this.enabled.checked && this.message.value.trim() ? this.message.value : preview.dataset.placeholder;
      const value = this.product.querySelector('[data-gift-preview-value]');
      if (value) value.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: this.product.dataset.currency || 'GBP', maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(Number(this.product.dataset.price) / 100);
      const lines = this.message.value ? this.message.value.split('\n').length : 0;
      this.querySelector('[data-gift-lines]').textContent = Math.max(0, 12 - lines);
      this.message.setCustomValidity(this.enabled.checked && lines > 12 ? this.dataset.linesError : '');
      this.querySelector('[data-gift-count]').textContent = 200 - this.message.value.length;
    }
  }
  customElements.define('gift-card-recipient', GiftCardRecipient);
})();
